import { Box } from "@chakra-ui/react";
import React from "react";

import { productName } from "lib/constants";
import { useInitStudentAuth } from "lib/features/auth/useInitAuth";

const TeacherStudentSession: React.FC = () => {
  useInitStudentAuth().then(() => {
    window.location.href = "/s/home";
  });

  // TODO: Translate
  return <Box>Opening {productName} as a student</Box>;
};

export default TeacherStudentSession;
